module.exports = __webpack_public_path__ + "media/images/covid/icons/tray-8760171c32da171ac60f1354ea393b1d.png";